import { PieceSymbol, DEFAULT_PIECES } from '../types/pieces';

/**
 * Creates an empty piece record with all required piece symbols initialized to empty strings
 */
export const createEmptyPieceRecord = (): Record<PieceSymbol, string> => {
  const record: Partial<Record<PieceSymbol, string>> = {};
  DEFAULT_PIECES.forEach(piece => {
    record[piece] = '';
  });
  return record as Record<PieceSymbol, string>;
}; 